export default __webpack_public_path__ + "static/media/logoHanbiro.b992b408.svg";